import React from 'react';
import { List } from 'antd';
import SummaryCard from '@/components/ProjectDetails/Cards/SummaryCard';
import { F } from '@/utils/intl';
import { Message } from '@/components/Communication/types';
import MessageItem from '@/components/ProjectDetails/Cards/Items/MessageItem';

export interface MessagesCardProps {
  messages: Message[];
  count: number;
  onShowAll?: (message?: Message) => void;
  onRefresh?: () => void;
}

const MessagesCard: React.FC<MessagesCardProps> = ({
  messages,
  count,
  onShowAll,
}) => {
  return (
    <SummaryCard
      title={<F id="entity.message.plural" defaultMessage="Messages" />}
      count={count}
      onShowAll={() => onShowAll?.()}
    >
      <List
        dataSource={messages}
        renderItem={(message) => (
          <MessageItem message={message} onClick={() => onShowAll?.(message)} />
        )}
      />
    </SummaryCard>
  );
};

export default MessagesCard;
